module.exports = __webpack_public_path__ + "img/nsyh.d9ec671d.png";